// Addresses are ONE line everywhere (questionnaires, client record, audit site): a multi-line address gets cut off
// in the quotation, the audit plan and the emails. Line breaks (typed, pasted or already saved) become ", ".
// The database does the same on save (sql/ONE_LINE_ADDRESS.sql), so every way in is covered.
export const oneLine = v => String(v ?? '')
  .replace(/^\s*[\r\n]+\s*|\s*[\r\n]+\s*$/g, '')      // a break at the very start / end → nothing (no stray comma)
  .replace(/\s*[\r\n]+\s*/g, ', ').replace(/,\s*,/g, ',')

// A single-address question in a questionnaire template (company_address, address …) — whatever type the template
// says, it is shown as a one-line box. "site_addresses" (a LIST of worksites) is not one of these.
export const isAddressField = q => { const id = String(q?.id || ''); return /(^|_)address$/i.test(id) && !/email/i.test(id) }
